import React from 'react'

import { BOOKING_STATUS, BOOKING_STATUS_LABEL } from 'constants/Booking'

import styles from './index.module.css'

const STATUS_CHIP_CLASS: Record<number, string> = {
  [BOOKING_STATUS.Unassigned]: styles.chipUnassigned,
  [BOOKING_STATUS.Recept]: styles.chipRecept,
  [BOOKING_STATUS.Booking]: styles.chipBooking,
  [BOOKING_STATUS.Confirmed]: styles.chipConfirmed,
  [BOOKING_STATUS.Delay_Expected]: styles.chipDelayExpected,
  [BOOKING_STATUS.Delay]: styles.chipDelay,
  [BOOKING_STATUS.Arrival]: styles.chipArrival,
  [BOOKING_STATUS.Calling]: styles.chipCalling,
  [BOOKING_STATUS.Working]: styles.chipWorking,
  [BOOKING_STATUS.Finish]: styles.chipFinish,
}

const getStatusLabel = (status: number): string =>
  BOOKING_STATUS_LABEL[status as keyof typeof BOOKING_STATUS_LABEL] ?? ''

type Props = {
  status: number
}

export const StatusChip: React.FC<Props> = ({ status }) => (
  <span className={`${styles.statusChip} ${STATUS_CHIP_CLASS[status] ?? ''}`.trim()}>
    {getStatusLabel(status)}
  </span>
)
